import warning from 'tiny-warning'

const bDebug = false
const preD = 'XXX notifyListeners.ts'

function createTransitionManager() {
  let prompt = null

  function setPrompt(nextPrompt) {
    warning(prompt == null, 'A history supports only one prompt at a time')
    prompt = nextPrompt
    return () => {
      if (prompt === nextPrompt) prompt = null
    }
  }

  let listeners = []

  function appendListener(fn) {
    let isActive = true

    function listener(...args) {
      if (isActive) fn(...args)
    }

    listeners.push(listener)

    return () => {
      isActive = false
      listeners = listeners.filter((item) => item !== listener)
    }
  }

  function notifyListeners(...args) {
    bDebug && console.log(`${preD} notifyListeners`, { listeners, args })

    listeners.forEach((listener) => {
      bDebug && console.log(`${preD} listeners.forEach`, { listener, args })
      return listener(...args)
    })
  }

  return {
    setPrompt,
    appendListener,
    notifyListeners,
  }
}

export default createTransitionManager
